export default "__VITE_ASSET__Bg06jysi__"